module.exports = __webpack_public_path__ + "static/media/2.cf6f70da.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/skin-cancer-surgery-mohs/2.gif
// module id = 666
// module chunks = 0